export default "__VITE_ASSET__h5uqT_hF__"